export const NAMESPACE = 'main-nav';
export const MAIN_NAV_ID = 'main-nav';
export const CUSTOM_CLASSNAME_PREFIX = 'main-nav__child--';
export const RESPONSIVE_SKELETONS_ITEMS_COUNT = 10;
export const DESKTOP_SKELETONS_ITEMS_COUNT = 6;
export const DESKTOP_NAV_AVERAGE_ITEM_WIDTH = 180;
export const WIDE_NAV_AVERAGE_ITEM_WIDTH = 50;
export const NAVIGATION_INHERITANCE_BODY_CLASSNAME = 'navigation-inheritance';
export const STICKY_DISABLED_BODY_CLASSNAME = 'not-sticky';
